import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${import.meta.env['VITE_AZURE_TENANT_ID'] ?? 'common'}`,
    clientId: import.meta.env['VITE_AZURE_CLIENT_ID'],
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: '/',
    redirectUri:
      import.meta.env['VITE_AZURE_REDIRECT_URI'] ?? window.location.origin + '/taskpane.html',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};
console.log('MSAL Configuration initialized:', {
  clientId: msalConfig.auth.clientId,
  redirectUri: msalConfig.auth.redirectUri,
});

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: (import.meta.env['VITE_AZURE_SCOPES'] ?? 'User.Read').split(','),
};

/**
 * Request configuration for backend API access token
 * This token will be used in OBO flow to get Graph API token
 */
export const backendApiRequest = {
  scopes: [`api://${import.meta.env['VITE_AZURE_CLIENT_ID']}/access_as_user`],
};
